// ════════════════════════════════════════════════════════════════════════════
// VatNotice — the ONE statement of the VAT basis at every buy button (Stripe Tax adoption Phase 3,
// server-config/plans/stripe-tax-adoption.md § Phase 3: "consent copy at buy buttons ('VAT determined by your
// billing country at checkout')"; voice-assistant issue #2176).
//
// A NOTICE, not a consent gate. The lawful basis for determining VAT from the buyer's billing country is a
// legal obligation (GDPR Art. 6(1)(c) — plan fold F-C1), so there is no checkbox, nothing is disabled, nothing
// is stored: the copy simply tells the buyer, before they press buy, what decides the VAT on their purchase.
// Prices are tax-inclusive (Stripe Tax Phase 0), so the sticker price never moves — only how much of it is VAT.
//
// ONE wording, ONE place: every buy affordance renders <VatNotice/>; the sentence is never retyped elsewhere
// (setpoint-evals/stripe-tax-p3/SE-03 censuses the buy-intent callers and greps for a retyped copy).
// Firewall-neutral (`shared-ui/`), a pure renderer with no state.
// ════════════════════════════════════════════════════════════════════════════

export const VAT_NOTICE_COPY = 'VAT is determined by your billing country at checkout. Prices include VAT where applicable.';

interface Props {
  /** Centre the text (the top-up modal's own help line is centred). */
  center?: boolean;
}

export function VatNotice({ center = false }: Props) {
  return (
    <p
      class="vat-notice"
      data-testid="vat-notice"
      style={{
        margin: '8px 0 0',
        fontSize: '0.72rem',
        lineHeight: 1.4,
        color: 'var(--text-dim, #6c7086)',
        textAlign: center ? 'center' : 'left',
      }}
    >
      {VAT_NOTICE_COPY}
    </p>
  );
}
